import React, { useMemo, useState } from 'react';

import { string } from 'yup';

import { FormSection } from 'src/app/components/lib/form';
import { Input } from 'src/app/components/lib/input';
import { Modal } from 'src/app/components/lib/modal';

type SendTestPushModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSendClick: (sendTo: string) => void;
};

const yupPushSchema = string().required();

export function SendTestPushModal({ onSendClick, isOpen, onClose }: SendTestPushModalProps) {
  const [sendTo, setSendTo] = useState('');

  const isValidPush = useMemo(() => yupPushSchema.isValidSync(sendTo), [sendTo]);
  return (
    <Modal
      Content={
        <FormSection>
          <Input
            label='Account email to send push to:'
            labelPlacement='top'
            value={sendTo}
            onChange={(e) => setSendTo(e.target.value)}
          />
        </FormSection>
      }
      open={isOpen}
      primaryActions={[
        {
          label: 'Send',
          onClick: () => onSendClick(sendTo),
          disabled: !isValidPush,
        },
      ]}
      title='Send preview'
      onClose={onClose}
    />
  );
}
